import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { contactInfo } from '../config/contactInfo';

const PaymentStatus = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const orderId = params.get('id') || params.get('order_id') || '-';
  const paymentMethod = params.get('method') || 'cashfree';
  const initialStatus = params.get('status') || 'UNKNOWN';
  const [status, setStatus] = useState(initialStatus);
  const [verifying, setVerifying] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const formattedDate = new Date().toLocaleString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'
  });

  const statusColor = status === 'PAID' ? '#2e7d32' : status === 'CANCELLED' ? '#f57c00' : status === 'PAYMENT_FAILED' || status === 'FAILED' ? '#d32f2f' : '#455a64';

  useEffect(() => {
    const verify = async () => {
      if (!orderId) return;
      if (initialStatus !== 'UNKNOWN') return; // if status provided, trust it

      try {
        setVerifying(true);
        const resp = await fetch(`https://nqa1.in/api/${paymentMethod}/payment/status?order_id=${orderId}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
        const data = await resp.json();
        const normalized = data.data?.normalized_status || 'UNKNOWN';
setStatus(normalized);


        // Route to dedicated pages for consistency
        if (normalized === 'SUCCESS' && data.success) {
          navigate(`/thank-you?id=${orderId}&method=${paymentMethod}`, { replace: true });
        } else if (s === 'CANCELLED') {
          navigate(`/payment-cancelled?id=${orderId}&method=${paymentMethod}`, { replace: true });
        } else if (s === 'PAYMENT_FAILED' || s === 'FAILED') {
          const reason = encodeURIComponent(data.message || 'Payment failed');
          navigate(`/payment-failed?id=${orderId}&method=${paymentMethod}&reason=${reason}`, { replace: true });
        }
      } catch (err) {
        setError('Could not verify payment.');
      } finally {
        setVerifying(false);
      }
    };

    verify();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId, paymentMethod]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '70vh', padding: '20px' }}>
      <div style={{ maxWidth: 700, width: '100%', background: '#fff', borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,0.12)', padding: 28 }}>
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <h1 style={{ margin: '10px 0', fontSize: 28 }}>Payment Status</h1>
          <p style={{ color: '#555' }}>Here are the details of your payment.</p>
        </div>
        <div style={{ background: '#f7f7f9', borderRadius: 8, padding: 16, margin: '20px 0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e3e3e7' }}>
            <span style={{ fontWeight: 600 }}>Order ID:</span>
            <span>{orderId}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
            <span style={{ fontWeight: 600 }}>Date:</span>
            <span>{formattedDate}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
            <span style={{ fontWeight: 600 }}>Status:</span>
            <span style={{ color: statusColor, fontWeight: 700 }}>{verifying ? 'Verifying...' : status}</span>
          </div>
          {error && (
            <div style={{ marginTop: 10, color: '#d32f2f' }}>{error}</div>
          )}
        </div>
        <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
          <Link to="/donate" className="btn read-more-btn" style={{ textDecoration: 'none' }}>
            Donate Again
          </Link>
          <Link to="/" className="btn" style={{ border: '1px solid #ddd', textDecoration: 'none' }}>
            Back to Home
          </Link>
        </div>

        <p style={{ color: '#888', fontSize: 13, marginTop: 18 }}>
          Having trouble? Contact us at <strong>{contactInfo.email}</strong> or call <strong>+91-{contactInfo.phone}</strong>
        </p>
      </div>
    </div>
  );
};

export default PaymentStatus;
